<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>


    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList">
        <el-form-item v-if="isBlogAdmin" slot="buttonSlot">
          <el-button type="warning" icon="el-icon-upload2" @click="openSimulateDialog">模拟上报</el-button>
        </el-form-item>
      </toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl">
        <el-table-column type="selection" width="50"></el-table-column>
        <!-- <el-table-column type="index" width="80"></el-table-column> -->
        <el-table-column prop="CardId" label="卡号" width></el-table-column>
        <el-table-column prop="UserName" label="姓名" width></el-table-column>
        <el-table-column prop="DepartmentName" label="部门" width></el-table-column>
        <el-table-column prop="KqTerminalId" label="终端标识" width>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.RecordSource === 'class_schedule' || scope.row.KqTerminalId === '自动排班'" size="mini" type="info">自动排班</el-tag>
            <span v-else>{{ scope.row.KqTerminalId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TouchTime" label="刷卡时间" width></el-table-column>
        <el-table-column prop="TouchType" label="刷卡类型" width>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.TouchType === '离开校园'" size="mini" type="primary">离开校园</el-tag>
            <el-tag v-else-if="scope.row.TouchType === '上车'" size="mini" type="success">上车</el-tag>
            <el-tag v-else-if="scope.row.TouchType === '下车'" size="mini" type="warning">下车</el-tag>
            <span v-else>{{ scope.row.TouchType || '-' }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="KqImageFile" label="媒体文件" align="center" header-align="center">
          <template slot-scope="scope">
            <oss-media-thumbs :media="scope.row.KqImageFile" />
          </template>
        </el-table-column>

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <!-- 模拟上报弹窗：仅 blogadmin / admin -->
    <el-dialog
      title="模拟校车考勤上报"
      :visible.sync="simulateVisible"
      width="520px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="simulateForm" :model="simulateForm" :rules="simulateRules" label-width="96px" size="small">
        <el-form-item label="校车终端" prop="SchoolBusId">
          <el-select
            v-model="simulateForm.SchoolBusId"
            filterable
            clearable
            placeholder="选择校车终端"
            style="width: 100%"
            @change="onTerminalChange"
          >
            <el-option
              v-for="d in terminalOptions"
              :key="d.Id"
              :label="formatTerminalOption(d)"
              :value="String(d.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="学生" prop="UserId">
          <el-select
            v-model="simulateForm.UserId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="输入姓名/学号/卡号搜索（至少2字）"
            :remote-method="searchStudents"
            :loading="studentLoading"
            :no-data-text="studentSearchHint"
            style="width: 100%"
            @change="onStudentChange"
            @visible-change="onStudentSelectVisible"
          >
            <el-option
              v-for="s in studentOptions"
              :key="s.Id"
              :label="formatStudentOption(s)"
              :value="String(s.Id)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="方向" prop="TouchType">
          <el-radio-group v-model="simulateForm.TouchType">
            <el-radio label="up">上车</el-radio>
            <el-radio label="down">下车</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="刷卡时间" prop="TouchTime">
          <el-date-picker
            v-model="simulateForm.TouchTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择刷卡时间"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="simulateVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="simulateLoading" @click="submitSimulate">提交上报</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getetSchoolBusRecords } from '../../api/modules/misc';
import { BaseApiUrl } from '../../api/base';
import {
  getSchoolBusTerminalListPage,
  simulateSchoolBusReportRecord
} from '../../api/modules/attendance';
import { getStudentInfoListPage } from '../../api/modules/personnel';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import superAdminMixin from '../../mixins/superAdminMixin'

export default {
  components: { Toolbar, DepartmentPane },
  mixins: [superAdminMixin],
  data() {
    return {
      filters: {
      },
      searchList: [
        {
          label: '卡号',
          key: 'cardId',
        },
        {
          label: '开始日期',
          key: 'startDate',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
        {
          label: '记录来源',
          key: 'recordSource',
          type: 'select',
          options: [
            { label: '全部来源', value: '' },
            { label: '实际车载终端', value: 'terminal' },
            { label: '班主任自动排班', value: 'class_schedule' }
          ]
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      BaseApiUrl: BaseApiUrl, //网络前缀
      currentUser: null,
      simulateVisible: false,
      simulateLoading: false,
      terminalOptions: [],
      studentOptions: [],
      studentLoading: false,
      studentSearchHint: '请输入关键字搜索',
      lastStudentQuery: '',
      simulateForm: {
        SchoolBusId: '',
        SchoolBusNo: '',
        UserId: '',
        CardId: '',
        TouchType: 'up',
        TouchTime: ''
      },
      simulateRules: {
        SchoolBusId: [{ required: true, message: '请选择校车终端', trigger: 'change' }],
        UserId: [{ required: true, message: '请选择学生', trigger: 'change' }],
        TouchType: [{ required: true, message: '请选择方向', trigger: 'change' }],
        TouchTime: [{ required: true, message: '请选择刷卡时间', trigger: 'change' }]
      }
    };
  },
  computed: {
    schoolDepartmentId() {
      return this.$store.state.activeSchoolId || window.localStorage.getItem('activeSchoolId') || this.DepartmentId || ''
    }
  },
  methods: {

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;
      //NProgress.start();
      getetSchoolBusRecords(para).then(async (res) => {
        this.total = res.data.response.dataCount;
        const rows = res.data.response.data || [];
        await this.prefetchListOssMedia(rows, 'KqImageFile');
        this.users = rows;
        this.listLoading = false;
        //NProgress.done();
      });
    },

    formatNow() {
      const d = new Date()
      const p = (n) => (n < 10 ? '0' + n : '' + n)
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    },
    formatTerminalOption(d) {
      const name = (d.TerminalName || d.LicensePlate || d.TerminalId || '未命名终端').trim()
      const tid = (d.TerminalId || '').trim()
      // 名称与标识相同时只显示一份，避免「122（122）」重复感；都空时兜底显示主键
      if (tid && tid !== name) return `${name}（${tid}）`
      if (name) return name
      return d.Id != null ? `终端（${d.Id}）` : '未命名终端'
    },
    formatStudentOption(s) {
      const name = s.StuName || s.Name || ''
      const card = this.resolveStudentCard(s) || '无卡'
      const no = s.StuCode || s.StuNo || s.StudentNo || ''
      return no ? `${name} / ${no} / ${card}` : `${name} / ${card}`
    },
    /** 主卡号优先，否则取附属卡 */
    resolveStudentCard(s) {
      if (!s) return ''
      if (s.CardNumber) return String(s.CardNumber).trim()
      const domains = s.domains || s.Domains || []
      if (domains.length) {
        const first = domains[0]
        const v = (first && (first.value || first.Value || first.cardId || first.CardId)) || ''
        if (v) return String(v).trim()
      }
      if (s.OtherCardNo) {
        const part = String(s.OtherCardNo).split(/[，,]/)[0]
        return (part || '').trim()
      }
      return ''
    },
    async openSimulateDialog() {
      if (!this.isBlogAdmin) return
      this.simulateForm = {
        SchoolBusId: '',
        SchoolBusNo: '',
        UserId: '',
        CardId: '',
        TouchType: 'up',
        TouchTime: this.formatNow()
      }
      this.studentOptions = []
      this.lastStudentQuery = ''
      this.studentSearchHint = '请输入关键字搜索'
      this.simulateVisible = true
      // 等弹窗与 el-select 挂载后再拉终端，避免选中态显示主键 Id
      await this.$nextTick()
      await this.loadTerminals()
    },
    onStudentSelectVisible(visible) {
      if (!visible) return
      if (!this.studentOptions.length) {
        this.studentSearchHint = '请输入姓名/学号/卡号（至少2字）'
      }
    },
    async loadTerminals() {
      const res = await getSchoolBusTerminalListPage({
        page: 1,
        intPageSize: 200,
        departmentId: this.schoolDepartmentId || undefined
      })
      this.terminalOptions = (res.data && res.data.response && res.data.response.data) || []
      // 先清空，等 el-option 挂载后再赋默认值，避免 filterable 选中态回退显示主键 Id
      this.simulateForm.SchoolBusId = ''
      this.simulateForm.SchoolBusNo = ''
      if (!this.terminalOptions.length) return
      await this.$nextTick()
      await this.$nextTick()
      const first = this.terminalOptions[0]
      this.simulateForm.SchoolBusId = String(first.Id)
      this.onTerminalChange(this.simulateForm.SchoolBusId)
    },
    onTerminalChange(id) {
      const d = (this.terminalOptions || []).find(x => String(x.Id) === String(id))
      this.simulateForm.SchoolBusNo = d ? (d.TerminalId || '') : ''
    },
    /**
     * 远程搜索学生：必须关键字，最多返回 30 条
     */
    async searchStudents(query) {
      const q = (query || '').trim()
      this.lastStudentQuery = q
      if (q.length < 2) {
        this.studentOptions = []
        this.studentSearchHint = q ? '请再输入至少1个字' : '请输入姓名/学号/卡号（至少2字）'
        return
      }
      this.studentLoading = true
      this.studentSearchHint = '无匹配学生'
      try {
        const para = {
          page: 1,
          intPageSize: 30,
          departmentId: this.schoolDepartmentId || this.DepartmentId || undefined
        }
        if (/^\d+$/.test(q)) para.cardNo = q
        else para.stuName = q
        const res = await getStudentInfoListPage(para)
        const list = (res.data && res.data.response && res.data.response.data) || []
        this.studentOptions = list
        if (!list.length) this.studentSearchHint = '无匹配学生'
      } finally {
        this.studentLoading = false
      }
    },
    onStudentChange(userId) {
      const s = (this.studentOptions || []).find(x => String(x.Id) === String(userId))
      this.simulateForm.CardId = this.resolveStudentCard(s)
    },
    submitSimulate() {
      this.$refs.simulateForm.validate(async (ok) => {
        if (!ok) return
        if (!this.simulateForm.UserId && !this.simulateForm.CardId) {
          this.$message.warning('请选择学生')
          return
        }
        this.simulateLoading = true
        try {
          const touchTime = this.simulateForm.TouchTime
          const res = await simulateSchoolBusReportRecord({
            SchoolBusId: this.simulateForm.SchoolBusId || '',
            SchoolBusNo: this.simulateForm.SchoolBusNo || '',
            UserId: this.simulateForm.UserId || '',
            CardId: this.simulateForm.CardId || '',
            TouchType: this.simulateForm.TouchType,
            TouchTime: touchTime,
            ReportTime: touchTime,
            PickRecordId: ''
          })
          if (res.data && res.data.success) {
            this.$message.success(res.data.msg || '模拟上报成功')
            this.simulateVisible = false
            this.handleQuery()
          } else {
            this.$message.error((res.data && res.data.msg) || '模拟上报失败')
          }
        } catch (e) {
          this.$message.error('模拟上报请求失败')
        } finally {
          this.simulateLoading = false
        }
      })
    }
  },
  mounted() {
    if (window.localStorage.user) {
      try {
        this.currentUser = JSON.parse(window.localStorage.user)
      } catch (e) {
        this.currentUser = null
      }
    }
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

</style>
